import fieldMixin from '@maison/mixins/fieldMixin';

export default {
  mixins: [fieldMixin],

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    checkboxClasses() {
      return ['checkbox', { 'checkbox--invalid': this.isInvalid }];
    },
  },
};
